// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14Oqn","right":"Footer_right__2IoZY","buttons":"Footer_buttons__ADDVt"};